
































































import { Component, Vue, Prop } from 'vue-property-decorator'
import USA from '@/assets/img/us-adults.svg?inline'
import People from '@/assets/img/select-or-create-audience.svg?inline'
import AudienceCard from './AudienceCard.vue'
import * as db from '@shared/types/database'
import { Button } from '@alpha/ink'
import DropdownButton from '@/components/DropdownButton.vue'
import { formattedAgeRange, formattedGeographicLocation, formattedAudienceName } from '@/utilities/audience-mappers'
import Audience from '@/components/AudienceBuilder/Audience'

const US_ADULTS: Pick<Audience, 'id' | 'name'> = {
  id: '5da633a1d604b500042e1fb1',
  name: 'US Adults'
}

@Component({
  components: {
    Button,
    DropdownButton,
    USA,
    People,
    AudienceCard
  }
})
export default class AudienceSelect extends Vue {
  @Prop({ required: false }) readonly audience?: Partial<db.Audience>
  @Prop({ default: false }) readonly saving!: boolean

  get audienceSelected () {
    return !!this.audience
  }

  get USAdultsSelected () {
    return this.audience?.id === US_ADULTS.id
  }

  get name () {
    if (!this.audience) return ''
    return formattedAudienceName(this.audience)
  }

  get age () {
    if (!this.audience) return ''
    return formattedAgeRange(this.audience)
  }

  get location () {
    if (!this.audience) return ''
    return formattedGeographicLocation(this.audience)
  }

  selectUSAdults () {
    this.setAudience(US_ADULTS)
  }

  removeAudience () {
    this.setAudience(null)
  }

  setAudience (audience: Pick<Audience, 'id' | 'name'> | null) {
    this.$emit('set-audience', audience)
  }

  selectOrCreateAudience () {
    this.$emit('select-or-create-audience')
  }
}

